export const combineName = (firstName?: string | null, lastName?: string | null) =>
  [firstName?.trim(), lastName?.trim()].filter(Boolean).join(" ");

export const lowerFirstLetter = (text: string) => text.charAt(0).toLowerCase() + text.slice(1);
